import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[eskDialogFooter]',
  standalone:true
})
export class DialogFooterDirective {

  constructor(public templateRef: TemplateRef<any>) {}

}
